export default function api({ token = null, csrf = null } = {}) {
  let authToken = token;
  let csrfToken = csrf;

  const setToken = (newToken) => {
    authToken = newToken;
  };

  const setCSRF = (newCsrf) => {
    csrfToken = newCsrf;
  };

  const getCSRFToken = () => {
    if (!csrfToken) {
      csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    }
    return csrfToken;
  };

  // const buildQueryString = (params) => {
  //   return new URLSearchParams(params).toString();
  // };
  const buildQueryString = (obj, prefix = '') => {
    const query = [];

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        const paramKey = prefix ? `${prefix}[${key}]` : key;

        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          query.push(buildQueryString(value, paramKey));
        } else if (Array.isArray(value)) {
          value.forEach((val) => {
            query.push(`${encodeURIComponent(paramKey)}[]=${encodeURIComponent(val)}`);
          });
        } else {
          query.push(`${encodeURIComponent(paramKey)}=${encodeURIComponent(value)}`);
        }
      }
    }

    return query.join('&');
  };

  const handleResponse = async (response) => {
    const contentType = response.headers.get('Content-Type');
    const isJson = contentType && contentType.includes('application/json');
    const data = isJson ? await response.json() : await response.text();

    if (!response.ok) {
      throw { status: response.status, data };

      // TODO:
      // const error = new Error(
      //     data?.error || data?.message || response.statusText
      // );
      //
      // error.status = response.status;
      // error.data = data;
      // error.isServerError = true;
      //
      // throw error;
    }

    return data;
  };

  const request = async (method, url, { data = {}, headers = {}, success, error } = {}) => {
    let options = {
      method: method.toUpperCase(),
      headers: {
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
          ...(getCSRFToken() ? { 'X-CSRF-Token': getCSRFToken() } : {}),
        ...headers
      }
    };

    if (method === 'GET') {
      const query = buildQueryString(data);
      url += query ? (url.includes('?') ? '&' : '?') + query : '';
    } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
    }

    try {
      const response = await fetch(url, options);
      const result = await handleResponse(response);
      if (typeof success === 'function') success(result);
    } catch (err) {
      if (typeof error === 'function') error(err);
    }
  };

  return {
    get: (url, options = {}) => request('GET', url, options),
    post: (url, options = {}) => request('POST', url, options),
    setToken,
    setCSRF
  };
}
